import {styled, Theme} from "@mui/material/styles";
import {Box, CSSObject} from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";

const openedMixin = (theme: Theme): CSSObject => ({
  width: mobileDrawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(6)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(6)} + 1px)`,
  },
});

export const mobileDrawerWidth = 300;

export interface IMobileDrawerHeaderProps {
  open?: boolean
  variant?: "permanent" | "persistent" | "temporary"
}

export const MobileDrawerHeader = styled(Box, {
  // shouldForwardProp: (prop) => true
})<IMobileDrawerHeaderProps>(
  ({ theme, open }) => ({
  position: `fixed`,
  top: 115,
  left: open ? mobileDrawerWidth : 0,
  marginLeft: -12,
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "flex-end",
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create("left ", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  })
}));


interface IDrawerProps {
}

const MobileDrawer = styled(MuiDrawer, {
  // shouldForwardProp: (prop) => prop !== 'open'
})<IDrawerProps>(
  ({ theme, open }) => ({
    width: open ? mobileDrawerWidth : 0,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(open && {
      ...openedMixin(theme),
      '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
      ...closedMixin(theme),
      '& .MuiDrawer-paper': closedMixin(theme),
    }),
  }),
);

export default MobileDrawer